export const leftMainMenu = {
  menu: [
    {
      name: 'Home',
      code: 'home',
      inactiveImgUrl: '../../assets/images/home-inactive.svg',
      activeImgUrl: '../../assets/images/home-active.svg',
      nav: 'home',
      privilege: 'EchoHome',
    },
    {
      name: 'Device Management',
      code: 'device-management',
      inactiveImgUrl: '../../assets/images/device-management-inactive.svg',
      activeImgUrl: '../../assets/images/device_management_active.svg',
      nav: 'device-management',
      privilege: 'EchoDeviceManagement',
    },
    {
      name: 'Campaign Definitions',
      code: 'template-management',
      inactiveImgUrl: '../../assets/images/template-management-inactive.svg',
      activeImgUrl: '../../assets/images/template-management-active.svg',
      nav: 'template-management',
      privilege: 'EchoTemplateManagement',
    },
    {
      name: 'Batch Management',
      code: 'batch-management',
      inactiveImgUrl: '../../assets/images/batch-management-inactive.svg',
      activeImgUrl: '../../assets/images/batch-management-active.svg',
      nav: 'batch-management',
      privilege: 'EchoBatchManagement',
    }
  ],
};
